import React from 'react';
import Layout from "../components/layout";
import { H3 } from "../utils/Typography";
import SEO from "../components/seo";
import img from "../images/Repository page/Verify.png";
import ProductHeader from "../utils/ProductHeader";
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ImageHeader from "../utils/ImageHeader";
import ImageFooter from "../utils/ImageFooter";
import secure from "../images/Repository page/Secure 3.png";
import lock from "../images/Data structure/lock.png";
import fullcontrol from "../images/Repository page/Full Control 3.png";
import uptoDate from "../images/Repository page/Up to Date Document 3.png";
import traceability from "../images/Repository page/Traceability 3.png";
import exchange from "../images/Repository page/Document Exchange 3.png";
import cross from "../images/Repository page/Cross-Jurisdiction 3.png";
import duplication from "../images/Repository page/Avoid Duplication 3.png";
import request from "../images/Repository page/Allow for Non-Standard Request 3.png";
import img1 from "../images/Repository page/2-2-6.png";
import styled from "styled-components";
import CompanyFooter from "../utils/CompanyFooter";
const IndexHeader = styled.div`
display: flex;
grid-template-columns: 1fr;
grid-template-rows: 1fr;
align-items: left;
justify-items: left;

`;

const Products = () => {
    return (
        <Layout>
            <SEO title="Home" keywords={[`u-reg`, `ureg`, `KYC`, `utility`]} />
            <div className="container" >
                <br></br><br></br>
                <ProductHeader img={img} />
            </div>
            <br></br>
            {/* <Container>
            <font face="Arial">
                <Row css={{fontSize: '14px'}}>
                   <Col></Col>
                    <Col>
                        <Row>
                            <Col xs={4}>
                                <IndexHeader>
                                    <ImageHeader img={secure} />
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader img={fullcontrol} />
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader img={uptoDate} />
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader img={traceability} />
                                </IndexHeader>
                            </Col>
                            <Col>
                                <IndexHeader>
                                    <ImageHeader /><div>SECURE</div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div>FULL CONTROL</div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div><p css={{'margin-bottom':'0rem'}}>UP TO DATE</p>
                                        <p css={{'margin-bottom':'0rem'}}>DOCUMENTS</p></div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div>TRACEABILITY</div>
                                </IndexHeader>
                            </Col>
                        </Row>


                    </Col>
                    <Col>
                        <Row>
                            <Col xs={4}>
                                <IndexHeader>
                                    <ImageHeader img={exchange} />
                                </IndexHeader>
                                <IndexHeader>
                                <ImageHeader img={cross} />
                                </IndexHeader>
                                <IndexHeader>
                                <ImageHeader img={duplication} />
                                </IndexHeader>
                                <IndexHeader>
                                <ImageHeader img={request} />
                                </IndexHeader>
                            </Col>
                            <Col>
                                <IndexHeader>
                                    <ImageHeader /><div><p css={{'margin-bottom':'0rem'}}>DOCUMENT</p>
                                    <p css={{'margin-bottom':'0rem'}}>EXCHANGE</p></div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div><p css={{'margin-bottom':'0rem'}}>CROSS</p>
                                    <p css={{'margin-bottom':'0rem'}}>JURISDICTION</p></div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div><p css={{'margin-bottom':'0rem'}}>AVOID</p>
                                        <p css={{'margin-bottom':'0rem'}}>DUPLICATION</p></div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div><p css={{'margin-bottom':'0rem'}}>NON-STANDARD</p>
                                        <p css={{'margin-bottom':'0rem'}}>REQUESTS</p></div>
                                </IndexHeader>
                            </Col>
                        </Row>

                    </Col>
                    <Col><ImageFooter img={img1} /></Col>
                </Row>
                </font>
            </Container> */}
             <div className="container" >
            <CompanyFooter img={img1}/>   
            </div> 
        </Layout>
    );
};

export default Products;
